module.exports = __webpack_public_path__ + "static/media/dashboard.127e8e26.svg";